import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

const CHUNK_RECOVERY_KEY = 'mcdt_chunk_recovery_attempted';
const CHUNK_RECOVERY_PARAM = '__chunk_recovery';

function shouldRecoverFromChunkError(rawError: unknown): boolean {
  const message = typeof rawError === 'string' ? rawError : String(rawError ?? '');
  return (
    /ChunkLoadError/i.test(message) ||
    /Loading chunk [\w-]+ failed/i.test(message) ||
    /Failed to fetch dynamically imported module/i.test(message) ||
    /Importing a module script failed/i.test(message)
  );
}

function recoverFromChunkError(reason: unknown): void {
  if (!shouldRecoverFromChunkError(reason)) {
    return;
  }

  const alreadyRetried = sessionStorage.getItem(CHUNK_RECOVERY_KEY) === '1';
  if (alreadyRetried) {
    console.error('Chunk recovery already attempted for this tab.', reason);
    return;
  }

  sessionStorage.setItem(CHUNK_RECOVERY_KEY, '1');
  const url = new URL(window.location.href);
  url.searchParams.set(CHUNK_RECOVERY_PARAM, Date.now().toString());
  window.location.replace(url.toString());
}

window.addEventListener('error', (event) => {
  const fallbackMessage = event?.message ?? '';
  recoverFromChunkError(event.error ?? fallbackMessage);
});

window.addEventListener('unhandledrejection', (event) => {
  recoverFromChunkError(event.reason);
});

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => {
    sessionStorage.removeItem(CHUNK_RECOVERY_KEY);

    // Limpia el query param usado para cache-busting sin recargar de nuevo.
    const url = new URL(window.location.href);
    if (url.searchParams.has(CHUNK_RECOVERY_PARAM)) {
      url.searchParams.delete(CHUNK_RECOVERY_PARAM);
      window.history.replaceState(window.history.state, '', url.toString());
    }
  })
  .catch((err) => console.error(err));
